import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useGlobalState } from "../../../contexts/GlobalContext";
import { Alert, Button } from "@mui/material";
import BasicInfo from "./BasicInfo";
import BasicInterests from "./BasicInterests";
import WorkPlace from "./WorkPlace";
import { Regex, Routes } from "../../../utils/constants";
import { AxiosResponse } from "axios";
import { componentMapping, mappingNewUser, mappingUser } from "../../../utils/constants/constant";
import HomePlace from "./HomePlace";
import NewsletterSetting from "./NewsletterSetting";
import { useNotificationTimestamp } from "../../../hooks/features/notification/useNotificationTimestamp";
import { shouldBulkDownload } from "../../../utils/helpers/function";
interface IStateLocation {
  dataEdit: IUserMetaDataApi;
  isSettingComplete?: boolean;
  isFirstTime?: boolean;
  survey?: boolean;
  survey_id?: string;
  surveyMember?: boolean;
  webLinkId?: string;
}

interface Field {
  field: string;
  label: string;
}
const UserSetting: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = useState<IUserSettingState>({
    userMetaDataForm: {},
    userMetaDataDetail: {},
    isFirstTimeSetting: undefined,
    isSuccessSetting: false,
    currentBasicValid: 0,
    currentContactValid: 0,
    currentWorkPlaceValid: 0,
    currentInterestValid: 0,
    currentHomePlaceValid: 0,
    subContactValue: {},
    isDisableButton: false,
    errorMess: undefined,
    errorFormBasic: undefined,
    errorFormContact: undefined,
    errorFormHomePlace: undefined,
  });

  const {
    userMetaDataForm,
    userMetaDataDetail,
    isFirstTimeSetting,
    isSuccessSetting,
    currentBasicValid,
    currentContactValid,
    currentWorkPlaceValid,
    currentHomePlaceValid,
    currentInterestValid,
    subContactValue,
    isDisableButton,
    errorMess,
    errorFormBasic,
    errorFormContact,
    errorFormHomePlace,
  } = state;

  const { setStateValue, globalState } = useGlobalState();
  const { dataEdit, isSettingComplete, isFirstTime, survey, survey_id, surveyMember, webLinkId } =
  (location.state as IStateLocation) ?? {};
  const { user } = globalState;
  const user_id = user?.user_id;
  const [searchParams] = useSearchParams();
  const serviceId = searchParams.get("serviceid");
  const returnTo = searchParams.get("returnto");
  const sessionId = searchParams.get("session_id");
  const serviceIdNumber = serviceId ? Number(serviceId) : 0;
  const user_status = userMetaDataForm?.user_status;
  const userMetaData = globalState.user?.user_metadata;
  const { checkNewsletterFromMailmagId } = useNotificationTimestamp();
  const selectedComponents = (serviceId &&
    componentMapping[serviceIdNumber]) || (user_status === 1 || user_status === 3 ?  mappingNewUser : mappingUser);
  const BasicInfoFields = [
    { field: "profile.fullName.firstName", label: "first_name" },
    { field: "profile.fullName.lastName", label: "last_name" },
    { field: "profile.fullNameKana.firstName", label: "first_name_kana" },
    { field: "profile.fullNameKana.lastName", label: "last_name_kana" },
    { field: "profile.birth.year", label: "year" },
    { field: "profile.birth.month", label: "month" },
    { field: "profile.birth.day", label: "day" },
    { field: "profile.occupationCode", label: "occupationCode" },
    { field: "profile.contactType", label: "contactType" },
  ];

  const PositionInfoFields = [
    { field: "workPlaceInfo.positionCode", label: "positionCode" },
    { field: "workPlaceInfo.affiliationCodes", label: "affiliationCodes" },
  ];

  const BasicInterestsFields =
    userMetaData?.transition_source === "kankyobusiness"
      ? [
        { field: "interest.environmentBusinessCodes", label: "environmentBusinessCodes" }
        ] 
      : [{ field: "interest.jobCodes", label: "jobCodes" }];

  const WorkPlaceFields = [
    { field: "workPlaceInfo.companyName", label: "companyName" },
    { field: "workPlaceInfo.phoneNumber", label: "phone03" },
    { field: "workPlaceInfo.city", label: "city" },
    { field: "workPlaceInfo.line", label: "line" },
    { field: "workPlaceInfo.postalCode", label: "zip02" },
    { field: "workPlaceInfo.prefectureCode", label: "prefectureCode" },
    { field: "workPlaceInfo.departmentName", label: "departmentName" },
  ];

  const HomePlaceFields = [
    { field: "profile.phoneNumber", label: "homePhone03" },
    { field: "profile.address.city", label: "city" },
    { field: "profile.address.line", label: "line" },
    { field: "profile.address.postalCode", label: "homeZip02" },
    { field: "profile.address.prefectureCode", label: "prefectureCode" },
  ];

  useEffect(() => {
    const overlay = document.getElementById("custom-overlay");
    if (overlay) {
      document.body.removeChild(overlay);
    }
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const returnTo = urlParams.get("returnto");
    if (returnTo) {
      localStorage.setItem("settingCallBackUrl", returnTo);
      localStorage.setItem("isUserSetting", "true");
    }
    if (dataEdit) {
      setState((prevState) => ({
        ...prevState,
        userMetaDataDetail: dataEdit,
        isFirstTimeSetting: isFirstTime,
      }));
    }
    document.title = "宣伝会議 : アカウント管理 | お客様情報の登録・変更";
  }, []);

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      isDisableButton:
        errorFormBasic || errorFormContact || errorFormHomePlace ? true : false,
    }));
  }, [errorFormBasic, errorFormContact, errorFormHomePlace]);

  useEffect(() => {
    if (isSettingComplete) {
      setState((prevState) => ({
        ...prevState,
        isSuccessSetting: isSettingComplete,
      }));
      navigate(
        `${Routes.USERSETTING}${serviceId ? "?serviceid=" + serviceId : ""}`,
        {
          replace: true,
          state: { dataEdit },
        }
      );
    }
  }, [isSettingComplete, dataEdit, navigate, location.pathname]);

  useEffect(() => {
    const settingCallBackUrl = localStorage.getItem("settingCallBackUrl");
    if (isSuccessSetting && settingCallBackUrl) {
      window.location.href = settingCallBackUrl;
      const isGoogleLogin = localStorage.getItem("isGoogleLogin");
      localStorage.clear();
      localStorage.setItem("isGoogleLogin", isGoogleLogin ?? "");

    }
  }, [isSuccessSetting]);

  useEffect(() => {
    if (
      userMetaDataForm?.profile?.contactType === 1 ||
      userMetaDataForm?.profile?.contactType === 2
    ) {
      setState((prevState) => ({
        ...prevState,
        userMetaDataDetail: userMetaDataForm,
      }));
    }
  }, [userMetaDataForm?.profile?.contactType]);

  useEffect(() => {
    if (!dataEdit && user) {
      handleFetchUserInfo();
    } else if (dataEdit) {
      setState((prevState) => ({
        ...prevState,
        isFirstTimeSetting: false,
        userMetaDataDetail: dataEdit,
        userMetaDataForm: dataEdit,
      }));
    }
  }, [user, dataEdit]);

  useEffect(() => {
    const savedUserMetaDataForm = localStorage.getItem("userMetaDataForm");

    if (savedUserMetaDataForm) {
      try {
        const parsedUserMetaDataForm = JSON.parse(savedUserMetaDataForm);

        setState((prevState) => ({
          ...prevState,
          userMetaDataForm: parsedUserMetaDataForm,
          userMetaDataDetail: parsedUserMetaDataForm,
          isFirstTimeSetting: isFirstTime,
        }));
      } catch (error) {
        console.error("Failed to parse userMetaDataForm from localStorage", error);
      }
    }
  }, []);

  const handleFetchUserInfo = async () => {
    setStateValue("loader", true);
    try {
      const timestampNewletter = new Date().toISOString();
      const { user_metadata } = globalState.user ?? {};
      const transitionSource = localStorage.getItem("transition_source");
      const mailMagId = localStorage.getItem("mailmagid");

      let updatedUserMetadata: IUserMetaDataApi = {
        ...user_metadata
      };
      // 初回設定の場合
      if (user_metadata.user_status === 1 || user_metadata.user_status === 3) {
        const isKankyo = user_metadata?.transition_source === "kankyobusiness" || transitionSource === "kankyobusiness";
        
        if (isKankyo) {
          updatedUserMetadata = {
            ...user_metadata,
            newsletterSubscription: {
              ...user_metadata.newsletterSubscription,
              contestsAwards: true,
              editorialBooks: true,
              sendenkaigiInfo: true,
              environmentalBusinessOnline: true,
              environmentalBusinessOnlineNews: true,
            }
          };
        } else {
          updatedUserMetadata = {
            ...user_metadata,
            newsletterSubscription: {
              ...user_metadata.newsletterSubscription,
              contestsAwards: true,
              editorialBooks: true,
              sendenkaigiInfo: true,
            }
          };
        }
        if (mailMagId) {
          updatedUserMetadata = checkNewsletterFromMailmagId(mailMagId, updatedUserMetadata);
        }
      }
      setStateValue("isShowMenu", !!user_metadata.profile);

      setState((prevState) => ({
        ...prevState,
        isFirstTimeSetting: !user_metadata.profile,
        userMetaDataDetail: updatedUserMetadata,
        userMetaDataForm: updatedUserMetadata,
      }));
    } catch (err) {
      if (!(err instanceof Error)) {
        const res = err as AxiosResponse;
        return res;
      }
    } finally {
      setStateValue("loader", false);
    }
  };

  const handleAddFields = () => {
    let requiredFields: Field[] = [];

    if(selectedComponents.includes("BasicInfo")){
      requiredFields =[...requiredFields, ...BasicInfoFields]
    }

    if(selectedComponents.includes("PositionInfo")){
      requiredFields =[...requiredFields, ...PositionInfoFields]
    }

    if(selectedComponents.includes("BasicInterests")){
      requiredFields =[...requiredFields, ...BasicInterestsFields]
    }

    if(userMetaDataDetail?.profile?.contactType !== 1 && selectedComponents.includes("WorkPlace")){
      requiredFields =[...requiredFields, ...WorkPlaceFields]
    }

    if(userMetaDataDetail?.profile?.contactType === 1 && selectedComponents.includes("HomePlace")){
      requiredFields =[...requiredFields, ...HomePlaceFields]
    }

    return requiredFields;
  };

  const handleCheckValidate = () => {
    const {
      homeZip01,
      homeZip02,
      zip01,
      zip02,
      mobile01,
      mobile02,
      mobile03,
      phone01,
      phone02,
      phone03,
      fax1,
      fax2,
      fax3,
      homeMobile01,
      homeMobile02,
      homeMobile03,
      homePhone01,
      homePhone02,
      homePhone03,
    } = subContactValue ?? {};
    const { day, month, year } = userMetaDataForm?.profile?.birth ?? {};
    const errors = [];

    const isAnyFilledFax = fax1 || fax2 || fax3;
    const isAllFilledFax = fax1 && fax2 && fax3;

    const isAnyFilledMobile = mobile01 || mobile02 || mobile03;
    const isAllFilledMobile = mobile01 && mobile02 && mobile03;

    const isAnyFilledHomeMobile = homeMobile01 || homeMobile02 || homeMobile03;
    const isAllFilledHomeMobile = homeMobile01 && homeMobile02 && homeMobile03;

    const isAnyFilledHomePhone = homePhone01 || homePhone02 || homePhone03;
    const isAllFilledHomePhone = homePhone01 && homePhone02 && homePhone03;

    const isAnyFilledWorkPhone = phone01 || phone02 || phone03;
    const isAllFilledWorkPhone = phone01 && phone02 && phone03;

    const isAnyFilledHomeZip =
      (homeZip01 && !homeZip02) || (!homeZip01 && homeZip02);
    const isAnyFilledWorkZip = (zip01 && !zip02) || (!zip01 && zip02);

    if (isAnyFilledHomeZip) {
      errors.push({
        field: "homeZip02",
        mess: "自宅郵便番号を正しく入力してください。",
      });
    }

    if (isAnyFilledWorkZip) {
      errors.push({
        field: "zip02",
        mess: "勤務先郵便番号を正しく入力してください。",
      });
    }

    const currentDate = new Date();
    const inputDate = new Date(year ?? 1901, (month ?? 1) - 1, day);
    if (inputDate > currentDate) {
      errors.push({
        field: "day",
        mess: t("validation.enterValidBirthDate"),
      });
    }
    if (isAnyFilledFax && !isAllFilledFax) {
      errors.push({
        field: "fax3",
        mess: t("validation.enterValidfaxNumber"),
      });
    }

    if (isAnyFilledMobile && !isAllFilledMobile) {
      errors.push({
        field: "mobile03",
        mess: t("validation.enterValidMobileNumber"),
      });
    }

    if (isAnyFilledHomeMobile && !isAllFilledHomeMobile) {
      errors.push({
        field: "homeMobile03",
        mess: t("validation.enterValidMobileNumber"),
      });
    }

    if (
      userMetaDataForm?.profile?.contactType !== 1 &&
      isAnyFilledHomePhone &&
      !isAllFilledHomePhone
    ) {
      errors.push({
        field: "homePhone03",
        mess: t("validation.enterValidMobileNumber"),
      });
    }

    if (
      userMetaDataForm?.profile?.contactType === 1 &&
      isAnyFilledWorkPhone &&
      !isAllFilledWorkPhone
    ) {
      errors.push({
        field: "phone03",
        mess: t("validation.enterValidMobileNumber"),
      });
    }

    const phones = [phone01, phone02, phone03];
    const joinedPhones = phones.join("");
    if (phones.every((phone) => phone)) {
      for (let i = 0; i < phones.length; i++) {
        if (!Regex.RULE.NUMBER.test(phones[i] ?? "")) {
          errors.push({
            field: `phone0${i + 1}`,
            mess: t("validation.landlineNumberOnlyDigits"),
          });
        }
      }
      if (joinedPhones.length > 12) {
        errors.push({
          field: "phone03",
          mess: t("validation.landlineNumberMax12Digits"),
        });
      }
    }

    const faxs = [fax1, fax2, fax3];
    const joinedFaxs = faxs.join("");
    if (faxs.every((fax) => fax)) {
      for (let i = 0; i < faxs.length; i++) {
        if (!Regex.RULE.NUMBER.test(faxs[i] ?? "")) {
          errors.push({
            field: `fax${i + 1}`,
            mess: t("validation.faxNumberOnlyNumbers"),
          });
        }
      }
      if (joinedFaxs.length > 12) {
        errors.push({
          field: "fax3",
          mess: t("validation.landlineFaxMax12Digits"),
        });
      }
    }

    const homePhones = [homePhone01, homePhone02, homePhone03];
    const joinedHomePhones = homePhones.join("");
    if (homePhones.every((phone) => phone)) {
      for (let i = 0; i < homePhones.length; i++) {
        if (!Regex.RULE.NUMBER.test(homePhones[i] ?? "")) {
          errors.push({
            field: `homePhone0${i + 1}`,
            mess: t("validation.landlineNumberOnlyDigits"),
          });
        }
      }
      if (joinedHomePhones.length > 12) {
        errors.push({
          field: "homePhone03",
          mess: t("validation.landlineNumberMax12Digits"),
        });
      }
    }

    // userMetaDataForm?.profile?.contactType === 1
    //   ? [...commonFields, ...contactTypeOneFields]
    //   : [...commonFields, ...contactTypeOtherFields];

    const requiredFields = handleAddFields();
    if (requiredFields.length > 0) {
      requiredFields.forEach(({ field, label }) => {
        const fieldValue = getNestedValue(userMetaDataForm, field);
        if (field == "profile.contactType") {
          if (!(fieldValue == 2 || fieldValue == 1)) {
            errors.push({
              field: label,
              mess: t("common.required"),
            });
          }
        } else if (
          field == "profile.birth.year" ||
          field == "profile.birth.month" ||
          field == "profile.birth.day"
        ) {
          if (!fieldValue || fieldValue == 0) {
            errors.push({
              field: label,
              mess: t("common.required"),
            });
          }
        } else if (!fieldValue || fieldValue.length === 0) {
          errors.push({
            field: label,
            mess: t("common.required"),
          });
        }
      });
    }

    return errors;
  };

  const getNestedValue = <T,>(obj: T | undefined, path: string): any => {
    if (!obj) return undefined;

    const keys = path.split(".");
    let result: any = obj;

    for (const key of keys) {
      if (result && key in result) {
        result = result[key];
      } else {
        return undefined;
      }
    }
    return result;
  };

  const handleScrollToTop = () => {
    document.documentElement.style.scrollBehavior = "auto";
    setTimeout(() => window.scrollTo(0, 0), 5);
    setTimeout(
      () => (document.documentElement.style.scrollBehavior = "smooth"),
      100
    );
  };

  const handleScrollToID = (id: string) => {
    document.documentElement.style.scrollBehavior = "auto";
    const element = document.getElementById(id);
    if (element) {
      setTimeout(() => {
        window.scrollTo({
          top: element.offsetTop - 50,
          behavior: "smooth",
        });
      }, 5);
    }

    setTimeout(() => {
      document.documentElement.style.scrollBehavior = "smooth";
    }, 100);
  };

  const handleConfirm = () => {
    const messErr = handleCheckValidate();

    if (messErr.length > 0) {
      const fieldErrorMapping: { [key: string]: string } = {
        //BasicInfo
        first_name: "BasicInfo",
        last_name: "BasicInfo",
        first_name_kana: "BasicInfo",
        last_name_kana: "BasicInfo",
        occupationCode: "BasicInfo",
        year: "BasicInfo",
        month: "BasicInfo",
        day: "BasicInfo",
        contactType: "BasicInfo",
        //PositionInfo
        positionCode: "PositionInfo",
        affiliationCodes: "PositionInfo",
        //BasicInterests
        jobCodes: "BasicInterests",
        environmentBusinessCodes: "BasicInterests",
        //WorkPlace
        companyName: "WorkPlace",
        zip01: "WorkPlace",
        zip02: "WorkPlace",
        phone03: "WorkPlace",
        departmentName: "WorkPlace",

        //HomePlace
        homeZip01: "HomePlace",
        homeZip02: "HomePlace",
        homePhone03: "HomePlace",

        //Work&Home
        prefectureCode: "WorkPlace",
        city: "WorkPlace",
        line: "WorkPlace",
      };

      const orderedMessErr = messErr.sort((a, b) => {
        const aIndex = Object.keys(fieldErrorMapping).indexOf(a.field);
        const bIndex = Object.keys(fieldErrorMapping).indexOf(b.field);

        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;

        return aIndex - bIndex;
      });

      const fieldError = orderedMessErr.find(
        (item) => fieldErrorMapping[item.field]
      );

      let id: string = fieldError ? fieldErrorMapping[fieldError.field] : "";
      //check Work&Home
      if (userMetaDataForm?.profile?.contactType === 1) {
        if (
          ["prefectureCode", "city", "line"].includes(fieldError?.field || "")
        ) {
          id = "HomePlace";
        }
      }

      handleScrollToID(id);
      setState((prevState) => ({
        ...prevState,
        isDisableButton: true,
        errorMess: messErr,
      }));
    } else {
      handleScrollToTop();
      localStorage.removeItem("mailmagid");
      localStorage.removeItem("session_id");
      localStorage.removeItem("serviceid_url");
      const confirmReturnTo =
        returnTo ||
        localStorage.getItem("settingCallBackUrl") ||
        localStorage.getItem("loginCallBackUrl");
      localStorage.removeItem("loginCallBackUrl");
      localStorage.removeItem("settingCallBackUrl");
      const params = new URLSearchParams();
      if (confirmReturnTo) params.append("returnto", confirmReturnTo);
      if (serviceId) params.append("serviceid", serviceId);
      if (sessionId) params.append("session_id", sessionId);
      if (shouldBulkDownload() || searchParams.get("bulkDownload") === "true") {
        params.append("bulkDownload", "true");
      }
      localStorage.setItem("userMetaDataForm", JSON.stringify(userMetaDataForm));

      const linkRedirect = `${Routes.USERSETTINGCONFIRM}${
        params.toString() ? `?${params.toString()}` : ""
      }`;
      navigate(
        linkRedirect,
        {
          state: { data: userMetaDataForm, isFirstTimeSetting, survey: survey, survey_id: survey_id, surveyMember: surveyMember, webLinkId: webLinkId},
        }
      );
    }
  };

  const totalRequired = () => {
    // let total = 2;
    // if (selectedComponents.includes("BasicInfo")) total += 7;
    // if (selectedComponents.includes("BasicInterests")) total += 1;
    // if (selectedComponents.includes("WorkPlace")) {
    //   const isContactType1 = userMetaDataForm?.profile?.contactType === 1;
    //   total += isContactType1 ? 5 : 6;
    // }
    let total = 0;

    if (selectedComponents.includes("BasicInfo")) {
      total += 9;
    }

    if (selectedComponents.includes("PositionInfo")) {
      total += 2;
    }

    if (selectedComponents.includes("BasicInterests")) {
      total += 1;
    }

    if (
      userMetaDataDetail?.profile?.contactType !== 1 &&
      selectedComponents.includes("WorkPlace")
    ) {
      total += 7;
    }

    if (
      userMetaDataDetail?.profile?.contactType === 1 &&
      selectedComponents.includes("HomePlace")
    ) {
      total += 5;
    }

    return total;
  };

  const totalvalidate = () => {
    // let total = currentBasicValid;
    // // if (selectedComponents.includes("BasicInfo")){
    // //   total += currentBasicValid;
    // // }
    // if (selectedComponents.includes("BasicInterests"))
    //   total += currentInterestValid;
    // if (selectedComponents.includes("WorkPlace")) {
    //   total += currentWorkPlaceValid;
    //   total += currentHomePlaceValid;
    // }

    // userMetaDataForm?.profile?.contactType === 1
    //   ? [...commonFields, ...contactTypeOneFields]
    //   : [...commonFields, ...contactTypeOtherFields];

    const requiredFields = handleAddFields();
    let total = 0;

    if(requiredFields.length > 0) {
      requiredFields.forEach(({ field }) => {
        const fieldValue = getNestedValue(userMetaDataForm, field);

        if (field == "profile.contactType") {
          if (fieldValue == 2 || fieldValue == 1) {
            total += 1;
          }
        } else if (
          field == "profile.birth.year" ||
          field == "profile.birth.month" ||
          field == "profile.birth.day"
        ) {
          if (!(!fieldValue || fieldValue == 0)) {
            total += 1;
          }
        } else if (!(!fieldValue || fieldValue.length === 0)) {
          total += 1;
        }
      });
    }

    return total;
  };

  return (
    <>
      {selectedComponents.length > 0 ? (
        <div className="setting">
          <div className="setting__mp-head">
            <div className="head-info">
              <div className="head-info__page-title">
                <span className="page-title__sm">お客様情報登録・変更</span>
              </div>
              {(user_status === 1 || user_status === 3) && (
                <div className="title-warning">
                  <span>
                    【ご利用・購入前に】
                    <br></br>
                    「必須項目」の入力を完了いただくと、商品購入や各種コンテンツがご利用可能になります。
                  </span>
                </div>
              )}
            </div>
            <div className="head-form_counter js-head-form_counter">
              <span className="head-form_counter-text">あと</span>
              <div className="head-form_counter-content">
                <strong className="head-form_counter-number js-head-form_number">
                  {totalRequired() - totalvalidate()}
                </strong>
                <span> / </span>
                <strong className="head-form_counter-total js-head-form_total">
                  {totalRequired()}
                </strong>
              </div>
            </div>
            <div className="main-form">
              {isSuccessSetting && (
                <Alert
                  sx={{
                    bgcolor: "#dff0d8",
                    color: "#3c763d",
                  }}
                  className="mt-3 mb-3"
                  icon={false}
                  severity="success"
                  onClose={() => {
                    setState((prevState) => ({
                      ...prevState,
                      isSuccessSetting: false,
                    }));
                  }}
                >
                  {t("features.userSetting.updateCompleted")}
                </Alert>
              )}

              <div className="register-form_sections">
                <BasicInfo
                  id="BasicInfo"
                  isShow={selectedComponents.includes("BasicInfo")}
                  isShowPosition={selectedComponents.includes("PositionInfo")}
                  errorMess={errorMess}
                  onChangeValidate={(value) => {
                    setState((prevState) => ({
                      ...prevState,
                      currentBasicValid: value ?? 0,
                    }));
                  }}
                  onGetErr={(value) => {
                    setState((prevState) => ({
                      ...prevState,
                      errorFormBasic: value,
                    }));
                  }}
                  formData={userMetaDataDetail ?? {}}
                  onChangeData={(value) => {
                    setState((prevData) => ({
                      ...prevData,
                      userMetaDataForm: {
                        ...prevData.userMetaDataForm,
                        profile: {
                          ...prevData.userMetaDataForm?.profile,
                          fullName: value.profile?.fullName,
                          fullNameKana: value.profile?.fullNameKana,
                          birth: value.profile?.birth,
                          genderCode: value.profile?.genderCode,
                          occupationCode: value.profile?.occupationCode,
                          contactType: value.profile?.contactType,
                        },
                        workPlaceInfo: {
                          ...prevData.userMetaDataForm?.workPlaceInfo,
                          positionCode: value.workPlaceInfo?.positionCode,
                          affiliationCodes:
                            value.workPlaceInfo?.affiliationCodes,
                        },
                      },
                    }));
                  }}
                />
                {selectedComponents.includes("BasicInterests") && (
                  <BasicInterests
                    id="BasicInterests"
                    errorMess={errorMess}
                    userData={userMetaDataDetail ?? {}}
                    onChangeData={(value: any) => {
                      setState((prevData) => ({
                        ...prevData,
                        userMetaDataForm: {
                          ...prevData.userMetaDataForm,
                          interest: {
                            ...prevData.userMetaDataForm?.interest,
                            industoryCodes: value.interest?.industoryCodes,
                            jobCodes: value.interest?.jobCodes,
                            jobChangeCode: value.interest?.jobChangeCode,
                            environmentBusinessCodes:
                              value.interest?.environmentBusinessCodes,
                          },
                        },
                      }));
                    }}
                    onChangeValidate={(value: any) => {
                      setState((prevState) => ({
                        ...prevState,
                        currentInterestValid: value ?? 0,
                      }));
                    }}
                  />
                )}
                {selectedComponents.includes("WorkPlace") && (
                  <WorkPlace
                    id="WorkPlace"
                    errorMess={errorMess}
                    onGetErr={(value) => {
                      setState((prevState: any) => ({
                        ...prevState,
                        errorFormContact: value,
                      }));
                    }}
                    onChangeSubData={(value: any) => {
                      setState((prevState) => ({
                        ...prevState,
                        subContactValue: {
                          ...prevState.subContactValue,
                          zip01: value.zip01,
                          zip02: value.zip02,
                          phone01: value.phone01,
                          phone03: value.phone03,
                          phone02: value.phone02,
                          mobile01: value.mobile01,
                          mobile02: value.mobile02,
                          mobile03: value.mobile03,
                          fax1: value.fax1,
                          fax2: value.fax2,
                          fax3: value.fax3,
                        },
                      }));
                    }}
                    formData={userMetaDataDetail ?? {}}
                    onChangeValidate={(value) => {
                      setState((prevState) => ({
                        ...prevState,
                        currentWorkPlaceValid: value ?? 0,
                      }));
                    }}
                    onChangeData={(value) => {
                      setState((prevData) => ({
                        ...prevData,
                        userMetaDataForm: {
                          ...prevData.userMetaDataForm,
                          workPlaceInfo: {
                            ...prevData.userMetaDataForm?.workPlaceInfo,
                            companyName: value.workPlaceInfo?.companyName,
                            postalCode: value.workPlaceInfo?.postalCode,
                            prefectureCode: value.workPlaceInfo?.prefectureCode,
                            city: value.workPlaceInfo?.city,
                            line: value.workPlaceInfo?.line,
                            departmentName: value.workPlaceInfo?.departmentName,
                            sameAsLoginEmailAddress:
                              value.workPlaceInfo?.sameAsLoginEmailAddress,
                            emailAddress: value.workPlaceInfo?.emailAddress,
                            phoneNumber: value.workPlaceInfo?.phoneNumber,
                            mobilePhoneNumber:
                              value.workPlaceInfo?.mobilePhoneNumber,
                            faxNumber: value.workPlaceInfo?.faxNumber,
                            lbcCode: value.workPlaceInfo?.lbcCode,
                          },
                        },
                      }));
                    }}
                    forceWorkPlaceValidate= {false}
                  />
                )}
                {selectedComponents.includes("HomePlace") && (
                  <HomePlace
                    id="HomePlace"
                    errorMess={errorMess}
                    onGetErr={(value) => {
                      setState((prevState: any) => ({
                        ...prevState,
                        errorFormHomePlace: value,
                      }));
                    }}
                    onChangeSubData={(value: any) => {
                      setState((prevState) => ({
                        ...prevState,
                        subContactValue: {
                          ...prevState.subContactValue,
                          homeZip01: value.homeZip01,
                          homeZip02: value.homeZip02,
                          homePhone01: value.homePhone01,
                          homePhone03: value.homePhone03,
                          homePhone02: value.homePhone02,
                          homeMobile01: value.homeMobile01,
                          homeMobile02: value.homeMobile02,
                          homeMobile03: value.homeMobile03,
                        },
                      }));
                    }}
                    formData={userMetaDataDetail ?? {}}
                    onChangeValidate={(value) => {
                      setState((prevState) => ({
                        ...prevState,
                        currentHomePlaceValid: value ?? 0,
                      }));
                    }}
                    onChangeData={(value) => {
                      setState((prevData) => ({
                        ...prevData,
                        userMetaDataForm: {
                          ...prevData.userMetaDataForm,
                          profile: {
                            ...prevData.userMetaDataForm?.profile,
                            address: value.profile?.address,
                            mobilePhoneNumber: value.profile?.mobilePhoneNumber,
                            phoneNumber: value.profile?.phoneNumber,
                          },
                        },
                      }));
                    }}
                    forceWorkPlaceValidate= {false}
                  />
                )}
                {selectedComponents.includes("NewsletterSetting") && (
                  <NewsletterSetting
                    data={userMetaDataDetail ?? {}}
                    onChangeData={(value) => {
                      setState((prevData) => ({
                        ...prevData,
                        userMetaDataForm: {
                          ...prevData.userMetaDataForm,
                          newsletterSubscription: {
                            ...prevData.userMetaDataForm
                              ?.newsletterSubscription,
                            sendenkaigiInfo:
                              value.newsletterSubscription?.sendenkaigiInfo,
                            classInfo: value.newsletterSubscription?.classInfo,
                            advertimes:
                              value.newsletterSubscription?.advertimes,
                            digitalMagazine:
                              value.newsletterSubscription?.digitalMagazine,
                            editorialSendenkaigi:
                              value.newsletterSubscription
                                ?.editorialSendenkaigi,
                            editorialHansokukaigi:
                              value.newsletterSubscription
                                ?.editorialHansokukaigi,
                            editorialKohokaigi:
                              value.newsletterSubscription?.editorialKohokaigi,
                            editorialBrain:
                              value.newsletterSubscription?.editorialBrain,
                            environmentalBusinessOnline:
                              value.newsletterSubscription?.environmentalBusinessOnline,
                            environmentalBusinessOnlineNews:
                              value.newsletterSubscription?.environmentalBusinessOnlineNews,
                            editorialBooks:
                              value.newsletterSubscription?.editorialBooks,
                            contestsAwards:
                              value.newsletterSubscription?.contestsAwards,
                            adPlacementSponsorship:
                              value.newsletterSubscription
                                ?.adPlacementSponsorship,
                            jobChangeInfo:
                              value.newsletterSubscription?.jobChangeInfo,
                          },
                        },
                      }));
                    }}
                  />
                )}
              </div>
              <div className="register-form_submit">
                <Button
                  // disabled={
                  //   isDisableButton || totalRequired() - totalvalidate() > 0
                  //     ? true
                  //     : false
                  // }
                  className="register-form_btn js-register-form_btn"
                  onClick={handleConfirm}
                >
                  {t("common.confirm")}
                </Button>
              </div>
            </div>
          </div>
          <div className="register-form_counter js-register-form_counter">
            <span className="register-form_counter-text">あと</span>
            <div className="register-form_counter-content">
              <div className="register-form_counter-bar js-register-form_bar">
                <svg
                  viewBox="0 0 100 100"
                  style={{ display: "block", width: "100%" }}
                >
                  <path
                    d="M 50,50 m 0,-47 a 47,47 0 1 1 0,94 a 47,47 0 1 1 0,-94"
                    stroke="#eaeaea"
                    strokeWidth="6"
                    fillOpacity="0"
                  />
                  <path
                    d="M 50,50 m 0,-47 a 47,47 0 1 1 0,94 a 47,47 0 1 1 0,-94"
                    stroke="#099"
                    strokeWidth="6"
                    fillOpacity="0"
                    style={{
                      strokeDasharray: "295.416",
                      strokeDashoffset:
                        (totalRequired() - totalvalidate()) *
                        (295.416 / totalRequired()),
                    }}
                  />
                </svg>
              </div>
              <strong className="register-form_counter-number js-register-form_number">
                {totalRequired() - totalvalidate()}
              </strong>
              <span className="register-form_counter-total js-register-form_total">
                {totalRequired()}
              </span>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default UserSetting;
